import { AlertOctagonIcon, CalculatorIcon, ClipboardCheckIcon, FlameIcon, ScanLineIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Motor Nameplate & Datasheet Decoder',
    description: 'Every field of IEC and NEMA nameplates explained, plus how to read datasheets and match a replacement motor.',
    icon: ScanLineIcon,
  },
  {
    number: '2',
    title: 'VFD Fault Diagnosis Field Guide',
    description: 'A brand-neutral guide to drive trips: overcurrent, overvoltage, undervoltage, ground fault, overload, overtemperature and more, with step-by-step checks.',
    icon: AlertOctagonIcon,
  },
  {
    number: '3',
    title: 'Motor Inspection & Testing Checklists',
    description: 'Ready-to-use checklists for receiving, installation, commissioning, routine inspection, lubrication and electrical tests.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '4',
    title: 'Motor Formulas & Quick Calculations',
    description: 'Speed, slip, torque, power, current, efficiency, starting, acceleration, affinity laws and unit conversions, each with a short example.',
    icon: CalculatorIcon,
  },
  {
    number: '5',
    title: 'Hazardous Area (Ex) Motors Essentials',
    description: 'Zones, gas groups, temperature classes, Ex d, Ex e, Ex n, Ex p and Ex t protection concepts, Ex marking, VFD considerations and inspection basics.',
    icon: FlameIcon,
  },
];
